// removed by extract-text-webpack-plugin
module.exports = {"entire":"entire_38eKX","whole":"whole_1BO9u","container":"container_31ZzR","selector":"selector_1kXzX","gap":"gap_dRhW3","customSelectors":"customSelectors_1LCMq","load-buttons":"load-buttons_34H2L","menu":"menu_1bpjA","menu-item":"menu-item_3R7ak","row_container":"row_container_2ebLA","reload":"reload_2apfr","tooltip":"tooltip_35zaW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/control_panel/size_panel/style.scss
// module id = 522
// module chunks = 0